import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;

if (!API_BASE) throw new Error("REACT_APP_API_BASE is required");

export const TOKEN_KEY = "auralive_session_token";

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  timeout: 20000,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getApiError = (error) =>
  error?.response?.data?.detail ||
  error?.response?.data?.message ||
  error?.message ||
  "The request could not be completed.";

export const extractList = (payload, keys = []) => {
  if (Array.isArray(payload)) return payload;
  for (const key of [...keys, "items", "results", "data"]) {
    if (Array.isArray(payload?.[key])) return payload[key];
  }
  return [];
};

export const entityId = (item, ...keys) =>
  keys.map((key) => item?.[key]).find(Boolean) || item?.id || item?._id;

export const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString();
};

export const displayName = (value) => {
  if (!value) return "—";
  if (typeof value === "string") return value;
  return value.display_name || value.name || value.username || value.email || value.id || "—";
};